import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {createAction as typedCreateAction} from 'web-app/util/redux/typed-action-helpers';
import {type SentReminder} from 'web-app/react/plans/debt-report-v2/debt-details/payment-reminders-modal/payment-reminders/types';

import {type SortingConfig} from './types';

const domain = 'DEBT_REPORT_V2';

export const {action: showingInstitutionId} = createAction(
    `${domain}/SHOWING_INSTITUTION_ID`,
    (institutionId: string) => ({
        institutionId,
    }),
);

export const {
    action: fetchOverviewData,
    success: fetchOverviewDataSuccess,
    failed: fetchOverviewDataFailed,
} = createAction(
    `DEBT_REPORT_V2/FETCH_OVERVIEW_DATA`,
    (input: {institutionId: string; asOf: string; includeCreditNotesAndCancelledInvoicesInBalance: boolean}) => ({
        ...input,
    }),
);

export const {action: fetchData} = typedCreateAction(
    'DEBT_REPORT_V2/FETCH_DATA',
    (input: {institutionId: string; asOf: string; includeCreditNotesAndCancelledInvoicesInBalance: boolean}) => ({
        ...input,
    }),
);

export const {action: fetchDataSuccess} = typedCreateAction(
    'DEBT_REPORT_V2/FETCH_DATA_SUCCESS',
    (input: {billPayerIds: string[]}) => ({
        ...input,
    }),
);

export const {action: fetchBalanceData} = typedCreateAction(
    'DEBT_REPORT_V2/FETCH_BALANCE_DATA',
    (input: {
        institutionId: string;
        asOf: string;
        includeCreditNotesAndCancelledInvoicesInBalance: boolean;
        billPayerIds: string[];
        expectedPaymentIds?: string[];
        unexpectedPaymentIds?: string[];
        expectedInvoiceIds?: string[];
        unexpectedInvoiceIds?: string[];
    }) => ({
        ...input,
    }),
);

export const {action: fetchBalanceDataSuccess} = typedCreateAction(
    'DEBT_REPORT_V2/FETCH_BALANCE_DATA_SUCCESS',
    result => ({result}),
);

export const {action: updateLatestPaymentReminders} = typedCreateAction(
    'DEBT_REPORT_V2/UPDATE_LATEST_PAYMENT_REMINDERS',
    (sentReminders: SentReminder[]) => ({
        sentReminders,
    }),
);

export const {action: updateSortBy} = typedCreateAction(
    'DEBT_REPORT_V2/UPDATE_SORT_BY',
    (sortBy: SortingConfig['column']) => sortBy,
);
